import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { intlShape } from "react-intl";
import { Field, reduxForm } from "redux-form";
import _ from "lodash";

import { TextInput } from "../../common/form";
import SearchResults from "./SearchResults";

import { MINIMUM_QUERY_LENGTH } from "./enums/searchBoxSettings";
import * as searchActions from "./searchActions";
import { cleanStringAndUnaccent } from "../../common/GraphQL/GraphQLQueryHelper";

class SearchBox extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.hideResults = this.hideResults.bind(this);
    this.handleChange = _.debounce(this.handleChange.bind(this), 300);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.performSearch = this.performSearch.bind(this);
    this.searchClients = _.debounce(this.searchClients.bind(this), 300);
    this.searchMembers = _.debounce(this.searchMembers.bind(this), 300);
  }

  handleChange(event) {
    const { value } = event.target;
    if (value.length < MINIMUM_QUERY_LENGTH) {
      this.props.searchActions.clearResults();
    } else if(cleanStringAndUnaccent(value)) {
      this.props.searchActions
        .updateSearch(value)
        .then(() => this.performSearch());
    }
  }

  handleKeyPress(event) {
    if (
      event.which == 13 &&
      event.target.value.length >= MINIMUM_QUERY_LENGTH
      && cleanStringAndUnaccent(this.props.searchString)
    ) {
      this.props.searchActions.forceOpen().then(() => this.performSearch());
    }
  }

  handleKeyDown(event) {
    if (event.which == 27) {
      this.props.searchActions.clearResults();
    }
  }

  hideResults() {
    this.props.reset();
    this.props.searchActions.clearResults();
  }

  performSearch() {
    if (this.props.showResults && this.props.searchString) {
      this.searchClients(
        0,
        this.props.clients.pagination.limit,
        this.props.searchString,
        this.props.clients.sortBy,
        true
      );
      this.searchMembers(
        0,
        this.props.members.pagination.limit,
        this.props.searchString,
        this.props.members.sortBy,
        true
      );
    }
  }

  searchClients(offset, limit, query, sortBy, bypass = false) {
    let { pagination } = this.props.clients;
    pagination.sortBy = this.props.clients.sortBy;
    if (
      pagination.offset !== offset ||
      pagination.limit !== limit ||
      !_.isEqual(pagination.sortBy, sortBy) ||
      bypass
    ) {
      this.props.searchActions.searchClients(
        offset,
        limit,
        this.props.searchString.trim(),
        sortBy
      );
    }
  }

  searchMembers(offset, limit, query, sortBy, bypass = false) {
    let { pagination } = this.props.members;
    pagination.sortBy = this.props.members.sortBy;
    if (
      pagination.offset !== offset ||
      pagination.limit !== limit ||
      !_.isEqual(pagination.sortBy, sortBy) ||
      bypass
    ) {
      this.props.searchActions.searchMembers(
        offset,
        limit,
        this.props.searchString.trim(),
        sortBy
      );
    }
  }

  render() {
    return (
      <div className="search-bar">
        <Field
          id="search"
          name="search"
          autoComplete="off"
          props={{
            onKeyPress: this.handleKeyPress,
            onKeyDown: this.handleKeyDown,
            onChange: this.handleChange,
          }}
          component={TextInput}
          type="search"
          placeholder={this.props.intl.formatMessage({
            id: "search.placeHolder",
          })}
        />
        <ReactCSSTransitionGroup
          transitionName="fade"
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {this.props.showResults && (
            <SearchResults
              key="searchResults"
              close={this.hideResults}
              clients={this.props.clients}
              members={this.props.members}
              searchClients={this.searchClients}
              searchMembers={this.searchMembers}
            />
          )}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

SearchBox.propTypes = {
  clients: PropTypes.object,
  members: PropTypes.object,
  searchActions: PropTypes.object,
  searchString: PropTypes.string,
  showResults: PropTypes.bool,
  reset: PropTypes.func,
  intl: intlShape,
};

function mapStateToProps(state) {
  return {
    clients: state.search.clients,
    members: state.search.members,
    searchString: state.search.searchString,
    showResults: state.search.showResults,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    searchActions: bindActionCreators(searchActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "searchBar",
  })(SearchBox)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/search/SearchBox.js